const header = document.querySelector('[data-header]')

const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
      header.classList.add('header--bg')
    } else {
      header.classList.remove('header--bg')
    }
  })
})

export default container => {
  container
    .querySelectorAll('[data-header-bg-toggle]')
    .forEach(section => observer.observe(section))
}
